import { Injectable } from "@angular/core";
import { MonitoringService } from "./monitoring.service";

@Injectable({
  providedIn: "root"
})
export class SharedMailboxService {
  private _targetMailbox: string | null = null;
  private _delegatePermissions: number | undefined = undefined;
  private _initialized = false;

  constructor(private readonly monitoringService: MonitoringService) {}

  setSharedMailbox(email: string, delegatePermissions?: number): void {
    this._targetMailbox = email;
    this._delegatePermissions = delegatePermissions;
    this._initialized = true;
  }

  clearSharedMailbox(): void {
    this._targetMailbox = null;
    this._delegatePermissions = undefined;
    this._initialized = true;
  }

  get isSharedMailbox(): boolean {
    return this._targetMailbox !== null;
  }

  /** True when the delegate has DeleteAll permission (Office.MailboxEnums.DelegatePermissions.DeleteAll = 8). */
  get canDeleteItems(): boolean {
    return ((this._delegatePermissions ?? 0) & 8) !== 0;
  }

  get targetMailbox(): string | null {
    return this._targetMailbox;
  }

  /** Returns "me" for regular mailbox, "users/email%40domain.com" (URI-encoded) for shared mailbox */
  get mailboxSegment(): string {
    if (!this._initialized) {
      // This should never happen — OfficeJSGuard always calls initializeSharedContextAsync before routes activate
      this.monitoringService.logFailed("SharedMailboxService", "mailboxSegment accessed before initialisation");
    }
    return this._targetMailbox
      ? `users/${encodeURIComponent(this._targetMailbox)}`
      : "me";
  }
}
